import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@omni/components/components/General/Image/image.default"
    ).then((module) => ({ default: module.ImageDefault }))
);
